
import { useRouter } from 'vue-router'
import { Dialog } from 'vant';
import {BTN_HANDEL} from '@/hooks/index'
import { watchEffect, ref, inject } from 'vue'
export default {
    components: {
    },
    props:{
        order_price_obj:{  //订单金额
            type: Object,
            required: true,
        },
    },
  setup(props: any, { emit }: any){
    let price_list: any = ref([])
    const $store: any = inject('$store')
    const currencyUnit:String = $store.getSymbol();
    watchEffect(() => {
        price_list.value = []
        let price_item = props.order_price_obj
        if(!price_item) return false;
        if(price_item.goods_order_amount) {
            price_list.value.push({
                label: 'Goods Amount:',
                value: `${currencyUnit}  ${price_item.goods_order_amount.thousands()}`,
                description: price_item.vat_show_status === 1 ? `(Incl: VAT ${currencyUnit} ${price_item.tax_total ? price_item.tax_total.thousands() : 0 } )` : null,
                shipping_description: price_item.tax_shipping_discount  ? `Kili Express Shipping Discount: ${currencyUnit} ${price_item.tax_shipping_discount.thousands()}` : null
            })
        }
        if(price_item.shipping_fee) {
            price_list.value.push({
                label: 'Shipping Fee:',
                value: `+ ${currencyUnit}  ${price_item.shipping_fee.thousands()}`,
            })
        }
        if(price_item.order_mansong_discount) {
            price_list.value.push({
                label: 'Goods Discount:',
                value: `- ${currencyUnit}  ${price_item.order_mansong_discount.thousands()}`,
            })
        }
        if(price_item.goods_discount) {
            price_list.value.push({
                label: 'Discount:',
                value: `- ${currencyUnit}  ${price_item.goods_discount.thousands()}`,
            })
        }
        if(price_item.coin_redeemed_price) {
            price_list.value.push({
                label: 'Coins Redeemed:',
                value: `- ${currencyUnit}  ${price_item.coin_redeemed_price.thousands()}`,
            })
        }
        if(price_item.promos_discount) {
            price_list.value.push({
                label: 'Promos:',
                value: `- ${currencyUnit}  ${price_item.promos_discount.thousands()}`,
            })
        }
        if(price_item.shipping_discount_amount) {
            price_list.value.push({
                label: 'Shipping Discount:',
                value: `- ${currencyUnit}  ${price_item.shipping_discount_amount.thousands()}`,
            })
        }
    });
    return {
        price_list
    }
  }
}
